export const getFileLoader = () => {
    const {
        NODE_ENV: env,
        VUE_APP_LAAS_CDN: cdn,
        VUE_APP_SALES_CHANNEL_BUCKET: bucket,
        VUE_APP_SALES_CHANNEL_SOURCE: source,
        BASE_URL: baseUrl,
    } = process.env;

    const useLocalS3 = env === 'development' && source === 's3';

    const fileLoader = async path => {
        let fullPath = `${baseUrl}data/${path}`;
        if (useLocalS3) {
            fullPath = `${cdn}/${bucket}/data/${path}`;
        }

        const response = await fetch(fullPath);

        return response.json();
    };

    return fileLoader;
};
